import { useCallback } from "react";
import SecurityService from "../services/security.service";
import environment from "../environments/environment.json";
import { localStore } from "../services/storage.service";


const DEVICE_KEY = "ipqs_device_id";
const TIMESTAMP_KEY = "ipqs_device_timestamp";
const MAX_AGE_HOURS = environment.IPQS_CACHE_HOUR;
const IP_KEY = "client_ip_key";

export const useIPQSCheck = () => {
  const checkIPQS = useCallback(
    async (transactionID, supplierUserId, supplierUid, surveyUid) => {
      return new Promise(async (resolve, reject) => {
       
        const now = Date.now();
        const storedTimestamp = localStore.getItem(TIMESTAMP_KEY);
        const deviceId = localStore.getItem(DEVICE_KEY);
        const lastIp = localStore.getItem(IP_KEY);

        const isExpired =
          !storedTimestamp ||
          now - parseInt(storedTimestamp, 10) >
            MAX_AGE_HOURS * 60 * 1000;

        if (
          !deviceId ||
          isExpired ||
          (await SecurityService.getIP()) !== lastIp
        ) {
          const script = document.createElement("script");
          script.src =
            "https://www.ipqscloud.com/api/rf.voqall.com/NQk4UfWeTD1V5lKa7TNqGAx9rE4Vp3WajaE0NXAxa1GVxWdtDqGLYGAdKEDdpHeb9lULbjOzwb9fyuEf5fo3jtCeEYaghtcWqAYNofYUxFEgHm7sAShrUUUByeF112OfOgwZ0gbNxmuXXDynekA1q9MC3wbNRdVo0nSFqHZ3rvjYtiGjytydBHoQ55OelRkUbOtG2qExMyI9VGaK4cQT9JyzntYJfsh2uk5PlJrcZe4lA8xEJjXiduVP5T9eEwnK/learn.js";
          script.crossOrigin = "anonymous";
          script.async = true;

          script.onload = () => {
            if (window.Startup && typeof window.Startup.Store === "function") {
              // Store your custom data
              window.Startup.Store("transactionID", transactionID);
              window.Startup.Store("subUserID", supplierUserId);
              window.Startup.Store("publisherID", supplierUid);
              window.Startup.Store("campaignID", surveyUid);
              window.Startup.Init();

              if (typeof window.Startup.AfterResult === "function") {
                window.Startup.AfterResult((result) => {
                  console.log(result);
                  localStore.setItem(DEVICE_KEY, result.device_id);
                  localStore.setItem(TIMESTAMP_KEY, now.toString());
                  localStore.setItem(IP_KEY, result.ip_address);

                  resolve(result);
                });
              } else {
                reject(new Error("Startup.AfterResult is not available."));
              }
            } else {
              reject(new Error("IPQS Startup object not available."));
            }
          };

          script.onerror = () =>
            reject(new Error("Failed to load IPQS script"));

          document.body.appendChild(script);
        } else {
          //get ip from
          resolve({ cached: true, device_id: deviceId });
        }
      });
    },
    []
  );

  return { checkIPQS };
};
